// @flow
import { TextOnlySearchEditor } from '../../common/TextOnlySearch';

export const LbaSearch = TextOnlySearchEditor;